import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';

import CustomFieldAddFormProto from "../../add-form-proto";
import CustomFieldLeftPanel from "../../common/panel/form-left-panel";
import CustomFieldPreview from "../../common/form-preview";
import CustomFieldRightPanel from "core/fields/custom/common/panel/form-right-panel";
import CustomFieldScale from "../../common/form-scale";

export default class StringCustomFieldForm extends CustomFieldAddFormProto {

    static propTypes = {
        customField: PropTypes.object,

        onSubmit: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props);

        this.type = gd.const.customFields.type.RATING;

        this.initFormData.ratingType = 5;

        if (this.props.customField) {
            this.initFormData.ratingType = _.get(this.props.customField.params,'ratingType', 5);
        }

        this.formStructure.fields.ratingType = {
            type: 'select',
            isRequired: true,
            label: 'Type',
            onUserChange: () =>  this.setState({reRender: 1})
        };

        this.form = new FormManager(this.formStructure, this.initFormData);
    }

    onSubmit(result) {
        result.name = result.name.trim();
        result.type = gd.const.customFields.type.RATING;

        result.params = {
            ratingType: result.ratingType,
            scope: result.scope
        };
        this.props.onSubmit(result);
    }

    renderPreview() {
        const res = [];
        const scale = this.form.getValue('ratingType');

        for (let i=1; i<=scale; i++) {
            let icon;
            if (i<scale) {
                icon = <div key={i} className="i5-star"/>
            } else {
                icon = <div key={i} className="i5-star-empty"/>
            }
            res.push(icon);
        }

        return (
            <div className="gd-field-rating m-l-15">
                {res}
            </div>
        )
    }

    render() {
        return (
            <React.Fragment>
                <CustomFieldLeftPanel parent={this}>
                    <CustomFieldPreview>
                        {this.renderPreview()}
                    </CustomFieldPreview>
                </CustomFieldLeftPanel>

                <CustomFieldRightPanel parent={this}>
                    <CustomFieldScale form={this.form}/>
                </CustomFieldRightPanel>
            </React.Fragment>
        )
    }
}